// DO NOT CHANGE
// Compiled by gulp ngtemplates:module. Adds templates to $templateCache.

/* jshint ignore:start */
angular.module("saturn.colorpicker").run(["$templateCache", function($templateCache) {$templateCache.put("saturn/colorpicker/colorpicker-row.tpl.html","<div class=\"color color--{{::color}}\"\n  ng-class=\"{\n    active: ctrl.activeColor === \'{{::color}}\',\n    dim: ctrl.activeColor && ctrl.activeColor !== \'{{::color}}\'\n  }\"\n  ng-click=\"ctrl.select(\'{{::color}}\')\">\n</div>");}]);
/* jshint ignore:end */


// WEBPACK FOOTER //
// ./~/@skycatch/skydash-saturn/boosters/colorpicker/src/templates.js